import classNames from 'classnames';
import { ReactNode } from 'react';

interface FiltersGroupProps {
  children: ReactNode;
  className?: string;
  variant?: 'inline' | 'expanded';
}

export const FiltersGroup = ({ children, className, variant = 'expanded' }: FiltersGroupProps) => (
  <div
    data-filter-group={variant}
    className={classNames(
      'max-sm:flex max-sm:w-full max-sm:min-w-0 max-sm:flex-col max-sm:items-stretch max-sm:gap-2',
      '[&>[data-filter-item]]:min-h-10',
      'max-sm:[&>:not(svg)]:!w-full max-sm:[&>:not(svg)]:!min-w-0 max-sm:[&>:not(svg)]:!max-w-none max-sm:[&>:not(svg)]:!flex-none',
      'max-sm:[&_[data-filter-value]]:!min-w-0 max-sm:[&_[data-filter-value]]:w-full max-sm:[&_[data-filter-value]]:flex-1',
      'max-sm:[&_[data-filter-value]>*]:min-w-0 max-sm:[&_[data-filter-value]>*]:max-w-full max-sm:[&_[data-filter-value]>*]:w-full',
      variant === 'inline' && [
        'sm:min-w-0 sm:w-auto',
        'sm:[&>:not(svg)]:w-[180px] sm:[&>:not(svg)]:min-w-0 sm:[&>:not(svg)]:max-w-[240px] sm:[&>:not(svg)]:flex-[0_1_180px]',
        'sm:[&>[data-filter-item=date]]:w-auto sm:[&>[data-filter-item=date]]:max-w-none sm:[&>[data-filter-item=date]]:basis-auto',
        'sm:[&_[data-filter-value]]:min-w-0 sm:[&_[data-filter-value]]:w-full sm:[&_[data-filter-value]]:flex-1',
      ],
      className,
    )}
  >
    {children}
  </div>
);
